/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SegnalazioneAccountListFilter { 
    stato?: SegnalazioneAccountListFilterStatoEnum;
    q?: string;
    da?: string;
    a?: string;
}
export enum SegnalazioneAccountListFilterStatoEnum {
    APERTA = 'APERTA',
    IN_LAVORAZIONE = 'IN_LAVORAZIONE',
    CHIUSA = 'CHIUSA'
};



